/**
 * Stellt eine Mini-Benchmark-Funktion zur Verfügung.
 *
 * Exportiert eine Factory-Funktion, welche beim ersten Aufruf einen Timer stellt
 * welcher beim Aufruf in die Konsole loggt und die benötigte Zeit zurück gibt.
 */


var timefunc;

if ( "production" !== process.env.NODE_ENV ) {

	if ( window.performance && typeof window.performance.now === "function" ) {

		timefunc = function(title) {
			var start = window.performance.now();
			return function(result_text) {
				var needed_time = (window.performance.now()) - start;
				result_text = result_text ? " -> " + result_text : "";
				result_text = (needed_time / 1000).toFixed(6) + " sec" + result_text;

				console.log("🍵 " + title + " -> " + result_text);
				return needed_time / 1000;
			};
		}

	} else {

		timefunc = function(title) {
			var start = new Date();
			return function(result_text) {
				var needed_time = (new Date()) - start;
				result_text = result_text ? " -> " + result_text : "";
				console.log("🍵 " + title + " -> " + ( needed_time > 1000 ? ((needed_time / 1000) + " sec") : (needed_time + " msec") ) + result_text);
				return needed_time / 1000;
			};
		}

	}

} else {

	timefunc = function(a) { return function(b) { return 0; } };

}

module.exports = timefunc;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/minitimer.js
 **/